import React from 'react';
import { Drawer } from 'antd';
import { MIN_MD } from 'constants/ThemeSetting';
import NotiBlock from 'components/NotiBlock/index';
import { useWindowSize } from 'react-use';
import { CloseOutlined } from '@ant-design/icons';
import NotFound from 'assets/svg/emtydata.svg';

function NotiDrawer({ onClose, visible }) {
  const { width } = useWindowSize();
  const notifications = [];

  const renderEmpty = () => {
    return (
      <div className="empty-noti flex justify-center items-center flex-col">
        <img src={NotFound} alt="Không có dữ liệu" />
        <p className="font-semibold text-sm text-grey-900 text-center">Bạn không có thông báo mới nào!</p>
      </div>
    );
  };

  return (
    <Drawer
      width={width >= MIN_MD ? '308px' : '100%'}
      title={
        <div className="flex items-center justify-between">
          <p className="text-base font-semibold">Thông báo (0)</p>
          <CloseOutlined onClick={onClose} />
        </div>
      }
      className="omi-noti-drawer"
      placement="right"
      maskStyle={{ backgroundColor: 'transparent' }}
      closable={false}
      onClose={onClose}
      visible={visible}
    >
      {notifications.length > 0 ? (
        <>
          <NotiBlock notRead />
          <NotiBlock notRead />
          <NotiBlock notRead />
          <NotiBlock />
          <NotiBlock />
          <NotiBlock />
        </>
      ) : (
        renderEmpty()
      )}
    </Drawer>
  );
}

export default NotiDrawer;
